import types from '../types'
import Helpers from '../Helpers'

export const summarize = (text) => (dispatch, getState) => {
  const oldSummaries = getState().userReducer.summaries || {}
  const data = {
    data: text,
  }
  Helpers.fetchPostJson(process.env.REACT_APP_ATLS + '/summarize', data)
      .then((res) => {
        console.log('res', res)
        if (res.content) {
          const newSummaries = {
            ...oldSummaries,
            [Date.now()]: res.content,
          }
          dispatch({
            type: types.STORE_PAYLOAD,
            payload: {
              summaries: newSummaries,
            },
          })
        }
      })
}
